import React from 'react'
import { MediaFormat } from 'frontend/enums'
import { FilterProp, PanelOption } from 'frontend/types'
import { activeOptionLabel } from 'frontend/utils/helpers'
import { filterMediaFormatClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import Panel from './Panel/Panel'
import { SearchParams } from 'backend/services/types/urApiService.types'

type FormatProps = {
  formats: FilterProp[]
  handlePanelClick: () => void
  isOpen: boolean
  searchParams: SearchParams
  updateSearch: (params: SearchParams) => void
}

const Format = ({
  formats,
  handlePanelClick,
  isOpen,
  searchParams,
  updateSearch,
}: FormatProps) => {
  const { format: mediaFormat } = searchParams

  const activeLabel = mediaFormat ? activeOptionLabel(formats, mediaFormat) : []

  const handleOptionSelect = (option: PanelOption) => {
    const isSelected = activeLabel.includes(option.label)

    if (!isSelected) filterMediaFormatClick(option.value as string)

    updateSearch({
      format: isSelected ? '' : (option.value as MediaFormat),
    })
  }

  return (
    <Panel
      activeLabels={activeLabel}
      ariaLabel="Filtrera på media"
      dataTrk="filter-format"
      handlePanelClick={handlePanelClick}
      isOpen={isOpen}
      label="Titta/Lyssna"
      onOptionSelect={handleOptionSelect}
      options={formats}
    />
  )
}

export default Format
